import { useMemo } from "react";
import RemoteResource from "../remoteResource/RemoteResource";
import useRemoteResource from "../remoteResource/useRemoteResource";
import Path from "../../models/ui/Path";

import Therapy from "../../models/domain/Therapy";
import TherapyMapper from "../../mappers/TherapyMapper";
import TherapyResponse from "../../models/serviceApi/TherapyResponse";

export default function useClinicTherapies(
  healthProviderId?: string,
): RemoteResource<TherapyResponse[]> {
  const query =
    healthProviderId && healthProviderId !== ""
      ? { healthProviderId }
      : undefined;

  const { error, isLoading, resource, refresh } = useRemoteResource<{
    therapies: TherapyResponse[];
  }>(
    query
      ? new Path(["api", "v1", "health-providers", "therapy"], query).toString()
      : null,
  );

  const mappedResource = useMemo(
    () =>
      resource
        ? TherapyMapper.mapResponseArrayToModel(resource.therapies)
        : undefined,
    [resource],
  );

  return {
    resource: mappedResource,
    isLoading,
    error,
    refresh,
  };
}
